import R from 'app/assets/R'
import { BasicRecord } from '../BasicRecord'

export const ArriveAtTheClinic = ({ timeString }: { timeString?: string }) => {
  return (
    <BasicRecord
      labelKeyI18n={R.strings.patient_arrive_at_the_clinic}
      timeString={timeString}
    />
  )
}
